import React from 'react';
import styled from 'styled-components/macro';
import Theme, {FontSizeType, FontWeightType} from "../constants/Theme";

interface textBaseProps {
  soft?: boolean;
  color?: 'black' | 'textGrey' | 'subHeadingGrey' | 'lightGrey' | 'darkBlue' | 'matteBlack' | 'white' | 'inherit' | 'success' | 'error' | 'pending';
  weight?: FontWeightType;
  className?: string;
  fontType?: 'Sora' | 'Galano' | 'Galano Alt';
  capitalize?: boolean;
  uppercase?: boolean;
  style?: object;
  title?: string;
  text?: string;
}
interface textProps extends textBaseProps {
  level?: FontSizeType;
}

type textHeadingLevels = 1 | 2 | 3 | 4 | 5;
interface textHeadingProps extends textBaseProps {
  level: textHeadingLevels;
}

type TextHeadingsComponent = React.FC<textHeadingProps>;
type TextComponent = React.FC<textProps>;
type TypographyBase = { Heading: TextHeadingsComponent; Text: TextComponent };

const isFont = (type: 'Sora' | 'Galano' | 'Galano Alt' | undefined) => {
  switch (type) {
    case 'Sora':
      return Theme.typography.primary;
    case 'Galano Alt':
      return Theme.typography.secondary;
    case 'Galano':
      return Theme.typography.secondary;
    default:
      return 'inherit';
  }
};

const TextStyling = styled.p<textProps>`
  display: block;
  font-family: ${({ fontType }) => isFont(fontType)};
  text-transform: ${({ capitalize, uppercase }) => (capitalize && 'capitalize') || (uppercase && 'uppercase')};
  font-size: ${({ level }) => level && Theme.fontSizes[level || 'large']};
  font-weight: ${({ weight }) => Theme.fontWeights[weight || 'thin']};
  color: ${({ soft, color }) =>
    (soft ? Theme.colorPalette.textGrey : Theme.colorPalette[color || 'inherit'])};
`;

export const Text: TextComponent = ({ children, text, ...rest }) => {
  return <TextStyling {...rest}>{text || children}</TextStyling>;
};

const Typography: TypographyBase = () => Text;

const TextHeading: TextHeadingsComponent = ({ children, level, ...rest }) => {
  const props = { weight: Theme.fontWeights.bold, as: `h${level || 1}`, ...rest } as any;
  return React.createElement(TextStyling, props, children);
};

Typography.Text = Text;
Typography.Heading = TextHeading;

export default Typography;
